import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

import { reviewsApi } from 'src/api';

import { setReviewsErrors, setReviewsMeta } from './reviews.slice';

import { normalizeErrorResponse } from 'src/utils';

export const getReviews = createAsyncThunk('reviews/get-reviews', async (data, thunkApi) => {
  try {
    const response = await reviewsApi.getUserReviews(data);

    thunkApi.dispatch(setReviewsMeta(response?.meta));

    return response?.data;
  } catch (error) {
    console.error(error);
  }
});

export const createReview = createAsyncThunk('reviews/create-review', async (data, thunkApi) => {
  try {
    const { payload, setFormData } = data;

    const response = await reviewsApi.createUserReview(payload);

    toast(response?.message, {
      type: response?.success ? 'success' : 'error',
      position: 'top-right',
    });

    setFormData({
      name: '',
      message: '',
    });

    thunkApi.dispatch(setReviewsErrors({}));

    return response;
  } catch (error) {
    const { response } = error;

    thunkApi.dispatch(setReviewsErrors(normalizeErrorResponse(response?.data?.errors)));
  }
});
